import { MenuSeparator } from '@tunasong/ui-lib'
import type { FC, ReactNode } from 'react'
import styles from './menu-groups.module.css'

export interface MenuGroupSpec {
  /** Stable name of the group, e.g. "organise" */
  key: string
  /** The group's rows; falsy entries are skipped */
  items: ReactNode[]
}

export interface MenuGroupsProps {
  /** Groups, top to bottom */
  groups: MenuGroupSpec[]
}

/**
 * Menu rows in groups, separated by dividers and no headings: the divider does the grouping (Gestalt proximity).
 * A group with no items renders nothing, divider included, and no divider leads the menu. A plugin component can still
 * render nothing at all; the stylesheet hides such a group and keeps dividers between visible groups only.
 */
export const MenuGroups: FC<MenuGroupsProps> = ({ groups }) => {
  const visible = groups
    .map(group => ({ ...group, items: group.items.filter(Boolean) }))
    .filter(group => group.items.length > 0)

  return (
    <>
      {visible.map((group, idx) => (
        <div key={group.key} className={styles.group} data-menu-group={group.key}>
          {idx > 0 ? <MenuSeparator className={styles.separator} /> : null}
          {group.items}
        </div>
      ))}
    </>
  )
}
